export const beforeItems = [
  'You observe difficulties during motor activities but struggle to organize the information.',
  'You review books, notes, and course materials trying to remember which concepts might be relevant.',
  'You find it difficult to separate observable motor performance from your interpretation.',
  'You aren’t always sure which task demands or contextual factors deserve further investigation.',
  'You sometimes focus on a possible explanation before identifying what information is missing.',
  'You finish reviewing a case with more questions than answers.',
  'Every complex praxis-related case feels like starting from zero.',
];

export const afterItems = [
  'You define the functional concern before interpreting the motor observations.',
  'You document the task, context, instructions, and observable performance.',
  'You explore possible relationships between motor performance and task demands.',
  'You identify missing information before strengthening a working hypothesis.',
  'You consider alternative explanations rather than attributing every difficulty to praxis.',
  'You connect your observations with functional participation and meaningful activities.',
  'You follow a repeatable educational framework whenever you need to organize a complex case.',
];
